<app-header></app-header>

<div class="page-title-area page-title-style-two item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Acasa</a></li>
                <li>Tarife servicii</li>
            </ul>
            <h2>Servicii cu plata in cadrul CMDTAMP</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12">
                <table class="table table-sm">
                    <thead>
                      <tr>
                        <th scope="col">Grup de serviciu</th>
                        <th scope="col">Tip de serviciu</th>
                        <th scope="col">Pret</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Certificate Medicale</td>
                        <td>Certificat medical conducator auto (fara analize medicale)</td>
                        <td>RON 100</td>
                      </tr>
                      <tr>
                        <td>Consultatii</td>
                        <td>Consultatie ( pentru pacient din afara policlinicii )</td>
                        <td>RON 20</td>
                      </tr>
                    </tbody>
                  </table>
            </div>
        </div>
    </div>
</div>



